import React, { forwardRef, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import { classNames, initValue } from '../../../../utils';

const styles = makeStyles(() => ({
  root: {
    overflow: 'auto',
  },
}));

export default forwardRef(function Content({ children, setTableRef, allData, nextPageCall, pageSize, className }, ref) {
  const classes = styles();
  const PAGESIZE = pageSize ?? 1;
  let isLoading = false;

  const tempRef = useRef(null);
  const containerRef = initValue(ref, tempRef);
  useEffect(() => {
    if (typeof setTableRef === 'function') {
      setTableRef(containerRef);
    }
  }, [containerRef]);

  const initRefresh = async () => {
    const elem = containerRef.current;
    const bottom = 100;
    if (elem.scrollHeight < elem.clientHeight + bottom && !isLoading) {
      isLoading = true;
      const pageNo = parseInt(allData.length / PAGESIZE + 1);
      await nextPageCall(PAGESIZE, pageNo, true);
      isLoading = false;
    }
  };

  let isTouchArea = false;
  const scrollListener = () => {
    const { current } = containerRef;
    if (current.scrollHeight - current.scrollTop <= current.clientHeight + 2) {
      if (!isTouchArea) {
        isTouchArea = true;
        const pageNo = parseInt(allData.length / PAGESIZE + 1);
        nextPageCall(PAGESIZE, pageNo);
      }
    } else {
      isTouchArea = false;
    }
  };

  useEffect(() => {
    if (nextPageCall) {
      const resizeHandle = () => {
        (async () => {
          await initRefresh();
        })();
      };
      const current = containerRef.current;
      const nextPageCtr = () => {
        current.addEventListener('scroll', scrollListener);
        window.addEventListener('resize', resizeHandle);
      };
      nextPageCtr();
      (async () => {
        await initRefresh();
      })();

      return () => {
        current.removeEventListener('scroll', scrollListener);
        window.removeEventListener('resize', resizeHandle);
      };
    }
  }, [allData]);

  return (
    <div ref={containerRef} className={classNames(classes.root, className)}>
      {children}
    </div>
  );
});
